/* eslint-disable */
import React from 'react';
import { PhotoCapture } from '../_shared/PhotoCapture';

function Page() {
  return (
    <PhotoCapture
      page="hairstyle-photo"
      progress={92}
      ns="hairstylePhoto"
      exampleName="upload-front-example.jpg"
      field="hairstyleFront"
      setter="setHairstyleFront"
      urlSetter="setHairstyleFrontUrl"
      outline="front"
    />
  );
}

export default Page;
